;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import type { ReactNode, SyntheticEvent } from "react"
import { styled } from "@mui/material/styles"
import MuiAccordion from "@mui/material/Accordion"
import MuiAccordionSummary from "@mui/material/AccordionSummary"
import MuiAccordionDetails from "@mui/material/AccordionDetails"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../lib/constants"

const Accordion = styled(MuiAccordion)(({ theme }) => ({
  background: "#EAEAEA",
  boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.25)",
  borderRadius: "15px !important",

  "&:not(:first-of-type)": {
    marginTop: "10px",
  },
  "& .MuiAccordion-rounded": {
    borderTopLeftRadius: "15px",
  },
  "&:before": {
    display: "none",
  },

  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "25px",
  letterSpacing: "0.03em",
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
}))

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}))

interface AccordionItemProps {
  panel: number
  section: string
  accordionSummaryTypography: ReactNode
  accordionDetailsTypography: ReactNode
  handleChange: (
    panel: number,
    section: string,
  ) => (event: SyntheticEvent, newExpanded: boolean) => void
  expanded: boolean
}

function AccordionItem({
  panel,
  section,
  accordionSummaryTypography,
  accordionDetailsTypography,
  handleChange,
  expanded,
}: AccordionItemProps) {
  return (
    <Accordion
      elevation={0}
      expanded={expanded}
      onChange={handleChange(panel, section)}
      key={`${panel}-${section}`}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${panel}-content`}
        id={`${panel}-header`}
      >
        {accordionSummaryTypography}
      </AccordionSummary>
      <AccordionDetails>{accordionDetailsTypography}</AccordionDetails>
    </Accordion>
  )
}

export default AccordionItem
